import React from 'react';
import { View } from 'react-native';
import { CheckBox } from 'react-native-elements';
import { Text } from '@/components/Text';
import { appTheme } from '@/config/colors';
import { styles } from './styles';

interface StayLoggedInProps {
  checked: boolean;
  onToggle: (value: boolean) => void;
  checkedColor?: string;
}

export const StayLoggedIn: React.FC<StayLoggedInProps> = ({
  checked,
  onToggle,
  checkedColor = appTheme.primary,
}) => {
  return (
    <CheckBox
      wrapperStyle={styles.stayLoggedInWrapper}
      size={28}
      containerStyle={styles.stayLoggedInContainer}
      checkedColor={checkedColor}
      checked={checked}
      onPress={() => onToggle(!checked)}
      title={
        <View style={{ marginLeft: 4 }}>
          <Text style={styles.stayLoggedInText}>
            Auf diesem Gerät angemeldet bleiben.
          </Text>
          <Text style={{ fontSize: 14 }}>
            Nur auf Ihrem eigenen Gerät empfohlen, um Zugriff von anderen zu
            vermeiden.
          </Text>
        </View>
      }
    />
  );
};
